import React, { Fragment } from 'react';
import BaseForm from '../../../../components/form/BaseForm';
import Input from '../../../../components/input/Input';
import SearchBox from '../../../../components/outline/SearchBox';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import Select from '../../../../components/input/Select';
import TextArea from '../../../../components/input/TextArea';
import { setClearDash, setIfNull, setTrim } from '../../../../lib/common';
import { ACCOUNT_USER_STATUS_SELECT_LIST } from '../../../../constants/service/app/accountUserConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { COUPON_GENERATE_USER_FILTER_OPTION_MODEL } from '../../../../store/modules/coupon/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  COUPON_GENERATE_SEARCH_BOX_SELECT_LIST,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID,
} from '../../../../constants/service/app/couponConstants';
import './CouponGenerateSearchBox.scss';

const CouponGenerateSearchBox = (props) => {
  const { setData, getList, filterOption } = props;
  const { searchType } = filterOption;

  return (
    <SearchBox
      className="coupon-generate-search-box"
      onSearch={() => {
        getList({
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        setData({
          path: ['filterOption'],
          value: COUPON_GENERATE_USER_FILTER_OPTION_MODEL,
        });
        setData({
          path: ['list'],
          value: [],
        });
        setData({
          path: ['summary', 'totalCnt'],
          value: 0,
        });
        setData({
          path: ['pagination'],
          value: LIST_PAGINATION_MODEL,
        });
      }}
    >
      <BaseForm
        label={
          <div className="inline-form">
            <Select
              list={COUPON_GENERATE_SEARCH_BOX_SELECT_LIST}
              defaultValue={searchType.type}
              value={searchType.type}
              onChange={(value) => {
                setData({
                  path: ['filterOption', 'searchType', 'type'],
                  value,
                });
              }}
            />
          </div>
        }
        content={
          <div className="inline-form">
            <TextArea
              value={searchType.value}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
              onChange={(value) => {
                setData({
                  path: ['filterOption', 'searchType', 'value'],
                  value: setIfNull(setTrim(setClearDash(value))),
                });
              }}
              onPressEnter={() =>
                getList({
                  filterOption,
                  pagination: LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="검색어"
        content={
          <Fragment>
            <div className="inline-form">
              <label>이름</label>
              <Input
                value={filterOption.name}
                onChange={(value) => {
                  setData({
                    path: ['filterOption', 'name'],
                    value: setIfNull(setTrim(value)),
                  });
                }}
                onPressEnter={() =>
                  getList({
                    filterOption,
                    pagination: LIST_PAGINATION_MODEL,
                  })
                }
              />
            </div>

            <div className="inline-form">
              <label>ID</label>
              <Input
                value={filterOption.account}
                onChange={(value) => {
                  setData({
                    path: ['filterOption', 'account'],
                    value: setIfNull(setTrim(value)),
                  });
                }}
                onPressEnter={() =>
                  getList({
                    filterOption,
                    pagination: LIST_PAGINATION_MODEL,
                  })
                }
              />
            </div>
          </Fragment>
        }
      />

      <BaseForm
        label="상태"
        content={
          <div className="inline-form">
            <Select
              list={ACCOUNT_USER_STATUS_SELECT_LIST}
              defaultValue={filterOption.status}
              value={filterOption.status}
              onChange={(value) => {
                setData({
                  path: ['filterOption', 'status'],
                  value,
                });
              }}
            />
          </div>
        }
      />

      <BaseForm
        label="가입일자"
        content={
          <div className="quick-date-picker">
            <DateRangePicker
              value={filterOption.createDate}
              format={DATE_FORMAT.YMD_DASH_FORMAT}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['filterOption', 'createDate'],
                  value,
                })
              }
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default CouponGenerateSearchBox;
